@if (!isMatMenuItem) {
  @if (!buttonType) {
    <button mat-button [attr.data-role]="role" matTooltip="{{ tooltip || '' | translate }}" [disabled]="disabled ? disabled : loading" (click)="clickAction()" [color]="color">
      <ng-container *ngTemplateOutlet="buttonBody"></ng-container>
    </button>
  }
  @if (buttonType === 'raised') {
    <button
      mat-raised-button
      [attr.data-role]="role"
      matTooltip="{{ tooltip || '' | translate }}"
      [disabled]="disabled ? disabled : loading"
      (click)="clickAction()"
      [color]="color"
    >
      <ng-container *ngTemplateOutlet="buttonBody"></ng-container>
    </button>
  }
  @if (buttonType === 'stroked') {
    <button
      mat-stroked-button
      [attr.data-role]="role"
      matTooltip="{{ tooltip || '' | translate }}"
      [disabled]="disabled ? disabled : loading"
      (click)="clickAction()"
      [color]="color"
    >
      <ng-container *ngTemplateOutlet="buttonBody"></ng-container>
    </button>
  }
  @if (buttonType === 'icon') {
    <button mat-icon-button [attr.data-role]="role" matTooltip="{{ tooltip || '' | translate }}" [disabled]="disabled ? disabled : loading" (click)="clickAction()" [color]="color">
      <ng-container *ngTemplateOutlet="buttonBody"></ng-container>
    </button>
  }
  <ng-template #buttonBody>
    @if (!loading) {
      @if (!useContent) {
        @if (icon) {
          <mat-icon>{{ icon }}</mat-icon>
        }
        <span>{{ taskLabel | translate }}</span>
      } @else {
        <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
      }
    } @else {
      <div class="card-operation-spinner">
        <app-loader [formField]="true" [delay]="0"></app-loader>
        <span>{{ loadingLabel | translate }}</span>
      </div>
    }
  </ng-template>
} @else {
  <button mat-menu-item [attr.data-role]="role" [disabled]="disabled ? disabled : loading" (click)="clickAction()">
    @if (!loading) {
      @if (!useContent) {
        @if (icon) {
          <mat-icon>{{ icon }}</mat-icon>
        }
        <span>{{ taskLabel | translate }}</span>
      } @else {
        <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
      }
    } @else {
      <div class="card-operation-spinner item-container">
        <span class="task-loader">
          <app-loader [formField]="true" [delay]="0"></app-loader>
        </span>
        <span>{{ loadingLabel | translate }}</span>
      </div>
    }
  </button>
}

<ng-template #contentTemplate>
  <ng-content></ng-content>
</ng-template>
